import axios from "axios";
import i18n from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ---- Persistent user identity (localStorage) ----
const USER_ID_KEY = "papicoo_user_id";
export const getUserId = () => {
  try {
    let id = localStorage.getItem(USER_ID_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `u-${Math.random().toString(36).slice(2)}-${Date.now()}`);
      localStorage.setItem(USER_ID_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};
export const resetUserId = () => {
  try { localStorage.removeItem(USER_ID_KEY); } catch (e) { console.warn("resetUserId failed:", e); }
};

// En-tête admin (présent seulement si l'admin s'est connecté dans ce navigateur)
export const adminHeaders = () => {
  try {
    const p = sessionStorage.getItem("papicoo_admin_pwd");
    return p ? { "X-Admin-Password": p } : {};
  } catch { return {}; }
};

export const isAdminSession = () => Object.keys(adminHeaders()).length > 0;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Chat fingerprint (freemium quota)
const CHAT_FP_KEY = "papicoo_chat_fp";
export const getChatFingerprint = () => {
  try {
    let fp = localStorage.getItem(CHAT_FP_KEY);
    if (!fp) {
      fp = "cfp_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(CHAT_FP_KEY, fp);
    }
    return fp;
  } catch { return null; }
};

export const sendChat = (payload) => http.post("/chat/send", { user_id: getUserId(), fingerprint: getChatFingerprint(), lang: i18n.language, ...payload }).then((r) => r.data);
export const listSessions = () => http.get("/chat/sessions", { params: { user_id: getUserId() } }).then((r) => r.data);
export const getSession = (id) => http.get(`/chat/sessions/${id}`, { params: { user_id: getUserId() } }).then((r) => r.data);
export const deleteSession = (id) => http.delete(`/chat/sessions/${id}`, { params: { user_id: getUserId() } }).then((r) => r.data);

export const studioTransform = (content, mode) =>
  http.post("/studio/transform", { content, mode }).then((r) => r.data);
export const studioReply = (post_context, comment) =>
  http.post("/studio/reply", { post_context, comment }).then((r) => r.data);

export const generateContract = (payload) =>
  http.post("/contracts/generate", payload).then((r) => r.data);

export const getThemes = () => http.get("/library/themes").then((r) => r.data);
export const getTheme = (slug) => http.get(`/library/themes/${slug}`).then((r) => r.data);

export const getProfile = () => http.get("/profile").then((r) => r.data);
export const coachProfile = (payload) => http.post("/profile/coach", payload).then((r) => r.data);

export const portraitStyles = () => http.get("/portrait/styles").then((r) => r.data);
export const enhancePortrait = (payload) => http.post("/portrait/enhance", payload, { timeout: 90000 }).then((r) => r.data);
export const absoluteUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;

export const liveAssist = (payload) => http.post("/live/assist", payload, { timeout: 60000 }).then((r) => r.data);
export const evotoRecipe = (payload) => http.post("/evoto/recipe", payload, { timeout: 60000 }).then((r) => r.data);
export const decodeMessage = (payload) => http.post("/decode", payload, { timeout: 60000 }).then((r) => r.data);
export const analyzeVideo = (payload) => http.post("/video/analyze", payload, { timeout: 90000 }).then((r) => r.data);

// ---- Profil utilisateur (prénom + genre) ----
export const fetchUserProfile = async () => {
  const id = getUserId();
  if (!id) return null;
  try {
    const { data } = await http.get(`/profile/${id}`);
    return data;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
};
export const saveUserProfile = (payload) => {
  const id = getUserId();
  return http.put(`/profile/${id}`, payload).then((r) => r.data);
};
export const deleteUserProfile = () => {
  const id = getUserId();
  return http.delete(`/profile/${id}`).then((r) => r.data);
};
